var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommentBase',{attrs:{"added-by":_vm.comment.addedBy,"text":_vm.comment.commentText,"subtitle":_vm.comment.getDateCreatedTimestamp()}})}
var staticRenderFns = []

export { render, staticRenderFns }